module.exports = function() {
  return new Worker(__webpack_public_path__ + "e446132e2b55e8fa6d0d.worker.js");
};